import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// team-members.html's #btnInvite icon: a stroked "+", not the filled cross PlusIcon/PlusFilledIcon
// render - those don't inherit color (PlusIcon is a static <img>) or read wrong at this weight.
const PlusOutline = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none">
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export default PlusOutline;
